<div class="m-4">
  <h2 class="mb-4" i18n="@@reject-driveorder.reject">Avslå</h2>
  <p class="mb-5" i18n="@@reject-driveorder.confirm">Bekräfta att du avslår utfallet på körordern.</p>

  <div class="d-flex">
    <button class="btn btn-outline-primary btn-min-width ms-auto me-2" id="dismissBtn" type="button" (click)="activeModal.dismiss()" [disabled]="buttonsDisabled" i18n="@@reject-driveorder.cancel">Avbryt</button>
    <button class="btn btn-primary btn-min-width" id="rejectBtn" type="button" (click)="reject()" [disabled]="buttonsDisabled" i18n="@@reject-driveorder.reject">Avslå</button>
  </div>
</div>
